// Every metric that decides where a glyph lands has to be identical on the field
// and its overlay, or the colored text drifts away from the caret.
export const HIGHLIGHT_METRICS = "px-3 text-sm font-mono"

export const HIGHLIGHT_RING_OK =
	"ring-gray-900/15 focus:ring-green-600/80 dark:ring-white/10 dark:hover:ring-white/20 dark:focus:ring-green-600/80"

/** For a box whose focus lives on a child, so it lights up with the field inside it. */
export const HIGHLIGHT_RING_WITHIN =
	"ring-gray-900/15 focus-within:ring-green-600/80 dark:ring-white/10 dark:hover:ring-white/20 dark:focus-within:ring-green-600/80"

export const HIGHLIGHT_RING_ERROR =
	"!ring-red-300 focus:!ring-red-600/80 dark:!ring-red-500/50 dark:focus:!ring-red-500"

// WebKit needs -webkit-text-fill-color as well, and hiding the text hides the caret
// with it unless caret-color is explicit.
export const HIGHLIGHT_HIDDEN_TEXT =
	"text-transparent [-webkit-text-fill-color:transparent]"

export const HIGHLIGHT_CARET =
	"caret-gray-900 selection:bg-gray-300/80 dark:caret-gray-50 dark:selection:bg-gray-600/80"
